module.exports = __webpack_public_path__ + "img/no_active.647c198b.png";